import React from 'react';
import {
  ContentWrapper,
  HeaderTitle,
  SubTitle,
  SummaryText,
} from './SectionPageTitleAndSummary.styles';
import { SectionPageTitleAndSummaryProps } from './types/SectionPageTitleAndSummary.types';

const SectionPageTitleAndSummary = ({
  section,
}: SectionPageTitleAndSummaryProps) => {
  const { title, subTitle, summaryText } = section;

  return (
    <ContentWrapper className="spring">
      <HeaderTitle>{title}</HeaderTitle>
      <SubTitle>{subTitle}</SubTitle>
      <SummaryText>{summaryText}</SummaryText>
    </ContentWrapper>
  );
};

export default SectionPageTitleAndSummary;
